import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormControlTouchStatusPatchDirective, RtUIModule } from '@recruitee/user-interface';

import { AvatarUploadComponent } from './components/avatar-upload/avatar-upload.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { CollapseComponent } from './components/collapse/collapse.component';

const components = [CollapseComponent, BreadcrumbsComponent, AvatarUploadComponent];

@NgModule({
  declarations: components,
  imports: [CommonModule, RtUIModule, RouterModule, FormControlTouchStatusPatchDirective],
  exports: components,
})
export class SharedModule {}
